import type { DashEnergyInfoKpiId, DashEnergyPeriodId } from './dash-energy-types';

/** Persisted split-info widget identifiers supported only at the dashboard decode boundary. */
export type LegacyDashEnergyInfoWidgetType =
	| 'dashEnergyInfoLiveConsumption'
	| 'dashEnergyInfoActiveGeneration'
	| 'dashEnergyInfoCost'
	| 'dashEnergyInfoBattery';

export const LEGACY_DASH_ENERGY_INFO_KPI_IDS: Record<
	LegacyDashEnergyInfoWidgetType,
	DashEnergyInfoKpiId
> = {
	dashEnergyInfoLiveConsumption: 'load',
	dashEnergyInfoActiveGeneration: 'solar',
	dashEnergyInfoCost: 'tariff',
	dashEnergyInfoBattery: 'selfPowered',
};

export const LEGACY_DASH_ENERGY_INFO_PERIODS: Record<
	LegacyDashEnergyInfoWidgetType,
	DashEnergyPeriodId
> = {
	dashEnergyInfoLiveConsumption: 'live',
	dashEnergyInfoActiveGeneration: 'live',
	dashEnergyInfoCost: '24_hours',
	dashEnergyInfoBattery: 'live',
};

const LEGACY_DASH_ENERGY_INFO_WIDGET_TYPES = Object.keys(
	LEGACY_DASH_ENERGY_INFO_KPI_IDS,
) as LegacyDashEnergyInfoWidgetType[];

export const isLegacyDashEnergyInfoWidgetType = (
	type: string | undefined,
): type is LegacyDashEnergyInfoWidgetType =>
	LEGACY_DASH_ENERGY_INFO_WIDGET_TYPES.includes(type as LegacyDashEnergyInfoWidgetType);
